import React from "react";
import "./sercices.css";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaThLarge,
  FaGlobe,
  FaLink,
  FaShoppingCart,
  FaUsers,
  FaFileAlt,
  FaMobileAlt,
  FaChartLine,
  FaBrain,
  FaArrowRight
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";


export default function Services() {
const navigate=useNavigate();
  const services = [
    {
      id: "custom-software-development",
      title: "Custom Software Development",
      desc: "Designing and building software applications from scratch based on client requirements with scalable architecture.",
      icon: <FaThLarge />,
    },
    {
      id: "web-development",
      title: "Web Development",
      desc: "Creating websites, web applications, and web-based solutions using various technologies and frameworks.",
      icon: <FaGlobe />,
    },
    {
      id: "blockchain-smart-contracts",
      title: "Blockchain & Smart Contracts",
      desc: "Building decentralized applications (DApps), implementing blockchain technology, and creating smart contracts.",
      icon: <FaLink />,
    },
    {
      id: "ecommerce-solutions",
      title: "E-Commerce Solutions",
      desc: "Developing custom e-commerce platforms and solutions tailored to client needs with payment integration.",
      icon: <FaShoppingCart />,
    },
    {
      id: "ux-ui-design",
      title: "UX/UI Design",
      desc: "Crafting user-centric interfaces and experiences to enhance usability and engagement.",
      icon: <FaUsers />,
    },
    {
      id: "whitepaper-creation",
      title: "Whitepaper Creation",
      desc: "Providing whitepaper creation services for clients looking to publish authoritative documents.",
      icon: <FaFileAlt />,
    },
    {
      id: "application-development",
      title: "Application Development",
      desc: "Building mobile and desktop applications with native performance and beautiful interfaces.",
      icon: <FaMobileAlt />,
    },
    {
      id: "consulting-strategy",
      title: "Consulting & Strategy",
      desc: "Expert advice, feasibility studies, and strategic planning for technology solutions aligned with business goals.",
      icon: <FaChartLine />,
    },
    {
      id: "ai-machine-learning",
      title: "AI & Machine Learning",
      desc: "Advanced AI solutions, predictive analytics, and machine learning models for intelligent automation.",
      icon: <FaBrain />,
    },
  ];

  // Simple animation variants
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5 }
  };
  
  // Handle navigation
  const handleNavigate = (serviceId) => {
    console.log('Navigating to:', serviceId);
    navigate(`/service/${serviceId}`);
  };
  
  return (
    <>
      <Helmet>
      <meta charset="UTF-8" />
      <link rel="icon" href="/img/CML_LOGO.png" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      <meta name="description" content="Chain Magician Lab - Your one-stop solution for all software requirements. We specialize in blockchain development, including Ethereum development and smart contracts. Our mobile application services cover e-commerce apps, gaming apps, Web3 apps, and more. We also provide custom software solutions tailored to your business needs, along with decentralized application development and secure, scalable software solutions." />
      <title>Chain Magician Lab | Blockchain, Mobile & Custom Software Development</title>
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.chainmagicianlab.com/" />
      <meta property="og:title:alt" content="Chain Magician Lab | Blockchain, Mobile & Custom Software Development" />
      <meta property="og:description" content="Chain Magician Lab offers high-quality blockchain development, mobile app creation including e-commerce, gaming, and Web3 apps, and custom software solutions to meet your business needs." />
      <meta property="og:image" content="https://www.chainmagicianlab.com/img/CML_LOGO.png" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://www.chainmagicianlab.com/" />
      <meta property="twitter:title" content="Chain Magician Lab | Blockchain, Mobile & Custom Software Development" />
      <meta property="twitter:description" content="Chain Magician Lab provides comprehensive software solutions including blockchain development, mobile apps (e-commerce, gaming, Web3), custom software, decentralized applications, and smart contracts." />
      <meta property="twitter:image:alt" content="https://www.chainmagicianlab.com/img/CML_LOGO.png" />
      <link rel="canonical" href="https://www.chainmagicianlab.com/" />
       <meta name="keywords" content="Blockchain development, Blockchain development company in India, Best blockchain company, Ethereum development services, Smart contract development, Smart contract developers India, dApp development company, Decentralized application development, Crypto exchange development India, Centralized exchange (CEX) development, Decentralized exchange (DEX) development, DEX aggregator platform, DEX liquidity pools, DEX security audits, DEX smart contracts, Cross-chain DEX development, Crypto arbitrage trading, Yield farming platform development, DeFi development company, DeFi staking platforms, DeFi lending protocols, DeFi token development, Cryptocurrency development, Crypto coin development, Crypto wallet development, Mobile crypto wallets, Web crypto wallets, Custodial and non-custodial wallets, ICO development company, STO development company, Token development services, Top token development company India, ERC-20 token development, BEP-20 token development, NFT token development, NFT marketplace development India, NFT smart contract solutions, NFT game development, Play-to-earn game development, NFT launchpad development, Tokenomics consulting, Token audit services, Token liquidity management, Token sale strategy, Token staking platform, Token governance models, Web3 integration company, Web3 application development, Web3 wallets, Web3 projects, Web3 APIs, Web3 infrastructure solutions, Web3 scalability, Web3 consulting India, Decentralized web solutions, DAO development services, Metaverse development company, Blockchain in healthcare India, Blockchain in supply chain India, Blockchain in fintech India, Blockchain consulting services, Blockchain architecture design, Blockchain protocol development, Blockchain auditing company, Blockchain security testing, Private blockchain development, Hyperledger development, Enterprise blockchain solutions, Blockchain IoT integration, AI and blockchain solutions, MLM software development company India, Best MLM software company, MLM compensation plans, Binary MLM plan software, Matrix MLM plan development, Unilevel MLM plan, Hybrid MLM software, Forced matrix MLM, MLM income calculator India, MLM business model solutions, MLM software features, MLM strategy consulting, MLM apps development, MLM software with blockchain, MLM company reviews India, Custom MLM software solutions, Mobile app development services, iOS app development India, Android app development company, Cross-platform mobile apps, Native app development services, Enterprise mobile app development, Mobile app UI/UX design, App store optimization, Mobile app testing services, Mobile app marketing, Mobile app maintenance, App deployment services, Custom mobile application solutions, Custom software development, Software development company in India, Enterprise software development, SaaS development company, PaaS development, Cloud software solutions, Software consulting India, Software modernization services, Bespoke software development, Software integration solutions, E-commerce website development India, Shopify development company India, Magento development, WooCommerce development, Custom e-commerce app development, Multi-vendor marketplace India, Online store development, E-commerce strategy consulting, E-commerce SEO services, Gaming app development company, Unity game development India, Unreal Engine game development, VR game development, AR game development, 2D game development, 3D game development, Multiplayer game apps, Educational game apps, Casual game development, Indie game development, Game monetization strategy, Blockchain gaming solutions, Play-to-earn game apps, Web3 gaming platforms, Crypto game development, Best blockchain consulting company India, Top blockchain companies in India, Best token development services, Crypto exchange developers India, Web3 developers India, Mobile app developers India, Custom software company India, Blockchain startup solutions, Token launch services, ICO launch company India.
.
"></meta>
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Chain Magician Lab",
            "url": "https://www.chainmagicianlab.com",
            "logo": "https://www.chainmagicianlab.com/img/CML_LOGO.png",
            "sameAs": [
             "https://www.facebook.com/chainmagicianlab",
              "https://www.twitter.com/chainmagicianlab",
              "https://www.linkedin.com/company/103792856",
              "https://wa.me/6393561379",
              "https://www.instagram.com/chainmagicianlab/",
              "https://t.me/Chain_Magician_Lab"
            ],
            "description": "Chain Magician Lab offers high-quality blockchain development, mobile app creation including e-commerce, gaming, and Web3 apps, and custom software solutions to meet your business needs."
          }
        `}
      </script>
    </Helmet>
    <section id="services" className="relative py-5 overflow-hidden bg-white ">
      {/* Premium Background Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-[#12AF09]/5 to-transparent rounded-full blur-[80px]"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-[#12AF09]/5 to-transparent rounded-full blur-[80px]"></div>
      
      {/* Subtle Grid Overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#f0f0f0_1px,transparent_1px),linear-gradient(to_bottom,#f0f0f0_1px,transparent_1px)] bg-[size:60px_60px] opacity-25"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4">
        {/* Page Title */}
        <motion.div 
          {...fadeInUp}
          className="mb-16"
        >
          <div className="inline-flex items-center gap-3 bg-white/80 backdrop-blur-sm border border-gray-200 rounded-full px-5 py-2 shadow-sm">
            <div className="w-2 h-2 rounded-full bg-[#12AF09] animate-pulse"></div>
            <span className="text-sm font-medium text-gray-600 tracking-wide">PAGE 02</span>
            <div className="w-10 h-px bg-gray-300"></div>
            <span className="text-sm font-semibold text-[#12AF09]">SERVICES</span>
          </div>
          <h2 className="text-3xl md:text-6xl font-bold text-gray-900 mt-6 tracking-tight">
            What We Deliver
          </h2>
        </motion.div>

        {/* Services Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
  {services.map((service, index) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.05 }}
      whileHover={{ y: -5 }}
      className="
      group relative bg-white rounded-2xl border border-gray-100
      p-4 md:p-6 transition-all duration-500
      
      shadow-[0_30px_50px_-20px_rgba(0,0,0,0.2)]
      md:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.1)]
      md:hover:shadow-[0_30px_50px_-20px_rgba(0,0,0,0.2)]
      md:hover:-translate-y-1
      "
    >

      {/* Premium SVG Pattern Background */}
      <svg
        className="
        absolute inset-0 w-full h-full
        opacity-10 md:opacity-0
        md:group-hover:opacity-10
        transition-opacity duration-500
        "
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern id={`grid-${index}`} width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#12AF09" strokeWidth="0.5" opacity="0.3"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#grid-${index})`} />
      </svg>

      {/* Floating Dots SVG */}
      <svg
        className="
        absolute top-0 right-0 w-32 h-32
        opacity-20 md:opacity-0
        group-hover:opacity-20
        transition-opacity duration-500
        "
        viewBox="0 0 100 100"
      >
        <circle cx="80" cy="20" r="4" fill="#12AF09" />
        <circle cx="60" cy="40" r="3" fill="#12AF09" />
        <circle cx="90" cy="60" r="2" fill="#12AF09" />
        <circle cx="40" cy="80" r="5" fill="#12AF09" />
      </svg>

      {/* Gradient Hover Overlay */}
      <div
        className="
        absolute inset-0 rounded-2xl
        bg-gradient-to-br from-[#12AF09]/5 via-transparent to-[#12AF09]/5
        
        md:from-[#12AF09]/0 md:to-[#12AF09]/0
        md:group-hover:from-[#12AF09]/5
        md:group-hover:to-[#12AF09]/5
        transition-all duration-500
        "
      />

      {/* Icon */}
      <div className="relative mb-6">
        <div
          className="
          w-14 h-14  flex items-center justify-center text-3xl
          rounded-xl transition-all duration-300
          
          text-white
          bg-gradient-to-br from-[#12AF09] to-[#1b8a10]
          
          scale-110 md:scale-100
          shadow-lg shadow-[#12AF09]/30 md:shadow-none
          
          md:group-hover:from-[#12AF09]
          md:group-hover:to-[#1b8a10]
          md:group-hover:text-white
          md:group-hover:scale-110
          md:group-hover:shadow-lg
          md:group-hover:shadow-[#12AF09]/30
          "
        >
          {service.icon}
        </div>

        <span
          className="
          absolute -top-3 -right-3 text-5xl font-black
          text-[#12AF09]/20 md:text-gray-100/70
          md:group-hover:text-[#12AF09]/20
          "
        >
          {(index + 1).toString().padStart(2, "0")}
        </span>

        <div
          className="
          absolute -bottom-2 -left-2 w-8 h-8 border-2
          border-[#12AF09]/30 md:border-[#12AF09]/10
          rounded-full transition-colors duration-300
          md:group-hover:border-[#12AF09]/30
          "
        />
      </div>

      {/* Title */}
      <h3
        className="
        text-xl font-bold mb-3 leading-tight
         text-gray-900
        group-hover:text-[#12AF09]
        transition-colors duration-300
        "
      >
        {service.title}
      </h3>

      {/* Description */}
      <p className="text-gray-600 leading-relaxed mb-6 text-sm font-medium">
        {service.desc}
      </p>

      {/* Button - FIXED: Added proper click handler and increased z-index */}
      <button
        type="button"
        className="
        inline-flex items-center gap-3 text-sm font-semibold
        text-[#12AF09] md:text-gray-500
        md:group-hover:text-[#12AF09]
        transition-all duration-300
        cursor-pointer relative z-20
        "
        onClick={(e) => {
          e.stopPropagation(); // Prevent event bubbling
          console.log('Button clicked for:', service.id);
          handleNavigate(service.id);
        }}
      >
        <span>Discover Service</span>
        <span
          className="
          w-6 h-6 rounded-full flex items-center justify-center
          bg-[#12AF09] md:bg-[#12AF09]/10
          md:group-hover:bg-[#12AF09]
          transition-all duration-300
          "
        >
          <FaArrowRight className="text-xs text-white md:text-[#12AF09] md:group-hover:text-white transition-all duration-300"/>
        </span>
      </button>

      {/* Bottom Line */}
      <div
        className="
        absolute bottom-0 left-1/2 -translate-x-1/2
        w-3/4 md:w-0 h-1
        bg-gradient-to-r from-[#12AF09] via-[#2fd61f] to-[#1b8a10]
        rounded-full transition-all duration-500
        md:group-hover:w-3/4
        "
      />

      {/* Corner Accents */}
      <div className="absolute top-4 left-4 w-8 h-8 border-t-2 border-l-2 border-[#12AF09]/30 md:border-[#12AF09]/0 rounded-tl-xl transition-all duration-500 md:group-hover:border-[#12AF09]/30"/>
      <div className="absolute bottom-4 right-4 w-8 h-8 border-b-2 border-r-2 border-[#12AF09]/30 md:border-[#12AF09]/0 rounded-br-xl transition-all duration-500 md:group-hover:border-[#12AF09]/30"/>

    </motion.div>
  ))}
</div>

        {/* Bottom CTA */}
        <div className="mt-20 text-center">
          <div className="inline-flex items-center gap-3 text-gray-400">
            <span className="w-12 h-px bg-gray-300"></span>
            <span className="text-sm">Innovative solutions for modern businesses</span>
            <span className="w-12 h-px bg-gray-300"></span>
          </div>
        </div>
      </div>

      {/* Add this CSS to fix mobile hover issues */}
      <style jsx>{`
        @media (max-width: 768px) {
          .group:hover .absolute {
            /* Ensure hover effects work on mobile */
            transition-duration: 300ms;
          }
          
          /* Make sure touch devices show hover effects on tap */
          .group:active {
            transform: translateY(-2px);
          }
          
          .group:active .w-16 {
            background: linear-gradient(to bottom right, #12AF09, #1b8a10);
            color: white;
            transform: scale(1.05);
          }
          
          .group:active h3 {
            color: #12AF09;
          }
          
          .group:active .w-6 {
            background: #12AF09;
          }
          
          .group:active .w-6 svg {
            color: white;
            transform: translateX(2px);
          }
        }
      `}</style>
    </section>
    </>
  );
}